import * as baseApi from '@/utils/tool'
const {
  ApiExecute
} = baseApi
var OSS = require('ali-oss')

/**
 * 获取Ali文件上传路径
 *
 * @export
 * @param {*} fileName
 * @param {*} fileType
 * @param {*} samePath
 * @param {*} company
 * @param {*} timeStamp
 * @returns
 */
export function GetAliFileUploadPath (viewID,
  fileName,
  fileSize,
  demoMethod,
  timeStamp,
  uploadRegionID,
  syncRegionID,
  isAccelerate) {
  const params = {
    appId: this.GLOBAL.AppID,
    method: 'GetAliFileUploadPath',
    viewID,
    fileName,
    fileSize,
    demoMethod,
    timeStamp,
    uploadRegionID,
    syncRegionID,
    isAccelerate
  }
  return ApiExecute(params)
}
/**
 * 获取Ali图片上传路径
 *
 * @export
 * @param {*} fileName
 * @param {*} fileType
 * @param {*} imageWidth
 * @param {*} imageHeight
 * @param {*} imageSize
 * @param {*} samePath
 * @param {*} company
 * @param {*} timeStamp
 * @returns
 */
export function GetAliImageUploadPath (
  viewID,
  fileName,
  demoMethod,
  imageWidth,
  imageHeight,
  imageSize,
  timeStamp,
  uploadRegionID,
  syncRegionID,
  isAccelerate
) {
  const params = {
    appId: 16,
    method: 'GetAliImageUploadPath',
    viewID,
    fileName,
    demoMethod,
    imageWidth,
    imageHeight,
    imageSize,
    timeStamp,
    uploadRegionID,
    syncRegionID,
    isAccelerate
  }
  return ApiExecute(params)
}

export function newClient (res, uploadRegion) {
  // 中文版 uploadRegion始终是 'cn-shanghai'
  return new Promise(resolve => {
    let client = new OSS({
      region: 'oss-' + res.RegionID,
      // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
      accessKeyId: res.AccessKeyId,
      accessKeySecret: res.AccessKeySecret,
      bucket: res.Bucket,
      stsToken: res.SecurityToken,
      secure: true
    })
    resolve(client)
  })
}



// WEBPACK FOOTER //
// ./src/Api/upload.js